import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<RugbyUnionIncidentId> =
  {
    isResultVisible: (incident) =>
      incident.status_id !== RugbyUnionEventStatusId.Penalties,
    scoringIncidents: new Map([]),
  }
